import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => (
  <h1 style={{ color: "white", textAlign: "center" }}>
    404 - <Link to="/">Go home</Link>
  </h1>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js